import React from "react";
import "../../../AllComponentCSS.css";

function JS_findIndex() {
  return (
    <div className="tutorial-page">
      <h1>JS findIndex</h1>
      <p>This page will cover the findIndex topic in detail.</p>
    </div>
  );
}

export default JS_findIndex;
